const PayementMethod = {
  cash: "Cash",
  card: "Card",
  upi: "UPI",
};

export default PayementMethod;
